import * as React from 'react'
import ReactTable, { CellInfo } from 'react-table'
import LocalizationStore from '../Stores/LocalizationStore'
import { Link } from 'react-router-dom'
import HttpActionsService from '../Services/HttpActionsService'
import DateTimeHelper from '../Helpers/DateTimeHelper'
import CatalogProductsStore from '../Stores/CatalogProductsStore'
import UserStore from '../Stores/UserStore'
import { history } from '../Routing'
import { Button } from 'react-bootstrap'
import Form, { AjvError, ISubmitEvent, FormValidation } from 'react-jsonschema-form'
import ActionsLocalService from '../Services/ActionsLocalService'
import QuestionnairesStore from '../Stores/QuestionnairesStore'
import ConfigStore from '../Stores/ConfigStore'
import * as FontAwesome from 'react-icons/lib/fa'
import * as _ from 'lodash'
import { IBaseProduct } from '../Model/Questionnaire'

const ls = LocalizationStore.getInstance()
const actionsLocalService = ActionsLocalService.getInstance()

export default class CatalogProduct implements IBaseProduct {
    id: string
    createDate: string
    updateDate: string
    externalKey: string
    name: string
    category: string
    price: number
    source: string
    isActive: boolean
    riskCategory: string
}

/// START TABLE
export class CatalogProductTableItem {
    constructor(p: CatalogProduct) {
        this.id = p.id
        this.createDate = DateTimeHelper.formatDateForList(p.createDate)
        this.updateDate = DateTimeHelper.formatDateForList(p.updateDate)
        this.externalKey = p.externalKey
        this.name = p.name
        this.category = p.category
        this.price = p.price
        this.source = p.source
        this.isActive = p.isActive.toString()

    }

    id: string
    createDate: string
    updateDate: string
    externalKey: string
    name: string
    category: string
    price: number
    source: string
    isActive: string
}

export function getPageCount() {
    return CatalogProductsStore.getInstance().getPageCount
}

export function createColumnsAdd() {
    const localizationStore = LocalizationStore.getInstance()

    return [
        {
            Header: localizationStore.t('PID'),
            maxWidth: 500,
            minWidth: 100,
            accessor: 'id',
            sortable: false,
            Cell: (cellInfo: CellInfo) => (
                <div>
                    <Button
                        hidden={cellInfo.row.isActive === 'false'}
                        onClick={(e) => {
                            actionsLocalService.updateQuestionnaireProductList({
                                id: undefined,
                                externalKey: cellInfo.row.externalKey,
                                name: cellInfo.row.name,
                                category: cellInfo.row.category === null ? '' : cellInfo.row.category,
                                price: cellInfo.row.price,
                                count: 1,
                                riskCategory: ""
                            })
                        }}
                    >
                        <FontAwesome.FaPlus
                            color="white"
                        />
                    </Button>
                    <Button
                        className="btn-danger"
                        onClick={(e) => {
                            actionsLocalService.updateQuestionnaireProductList({
                                id: undefined,
                                externalKey: cellInfo.row.externalKey,
                                name: cellInfo.row.name,
                                category: cellInfo.row.category,
                                price: cellInfo.row.price,
                                count: -1,
                                riskCategory: ""
                            })
                        }}
                    >
                        <FontAwesome.FaMinus
                            color="white"
                        />
                    </Button>
                </div>
            )
        },
        {
            Header: localizationStore.t('PID'),
            maxWidth: 500,
            minWidth: 100,
            accessor: 'id',
            sortable: false,
            Cell: (cellInfo: CellInfo) => (
                <Link
                    className="catalogProductDetailLink"
                    to={'/catalogProduct/' + cellInfo.row.id}
                    id={cellInfo.row.name}
                >
                    {cellInfo.row.id}
                </Link>
            )
        },
        {
            Header: localizationStore.t('date'),
            accessor: 'createDate',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        },
        {
            Header: localizationStore.t('updateDate'),
            accessor: 'updateDate',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        }
        ,
        {
            Header: localizationStore.t('source'),
            accessor: 'source',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        }
        ,
        {
            Header: localizationStore.t('externalProductKey'),
            accessor: 'externalKey',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        }
        ,
        {
            Header: localizationStore.t('name'),
            accessor: 'name',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        }
        ,
        {
            Header: localizationStore.t('category'),
            accessor: 'category',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        }
        ,
        {
            Header: localizationStore.t('price'),
            accessor: 'price',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        }
        ,
        {
            Header: localizationStore.t('isActive'),
            accessor: 'isActive',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        }
    ]
}
export function createColumnsQuestionnaireProducts() {
    const localizationStore = LocalizationStore.getInstance()

    return [
        {
            Header: localizationStore.t('externalProductKey'),
            accessor: 'externalKey',
            maxWidth: 300,
            minWidth: 100,
            sortable: false,
            filterable: false
        }
        ,
        {
            Header: localizationStore.t('name'),
            accessor: 'name',
            maxWidth: 300,
            minWidth: 100,
            sortable: false,
            filterable: false
        }
        ,
        {
            Header: localizationStore.t('category'),
            accessor: 'category',
            maxWidth: 300,
            minWidth: 100,
            sortable: false,
            filterable: false
        }
        ,
        {
            Header: localizationStore.t('price'),
            accessor: 'price',
            maxWidth: 300,
            minWidth: 100,
            sortable: false,
            filterable: false
        }
        ,
        {
            Header: localizationStore.t('count'),
            accessor: 'count',
            maxWidth: 300,
            minWidth: 100,
            sortable: false,
            filterable: false
        },
        {
            Header: localizationStore.t('riskCategory'),
            accessor: 'riskCategory',
            maxWidth: 200,
            minWidth: 100,
            sortable: false,
            filterable: false
        },
        {
            Header: localizationStore.t(''),
            maxWidth: 500,
            minWidth: 100,
            accessor: 'id',
            sortable: false,
            Cell: (cellInfo: CellInfo) => (
                <div>
                    <Button
                        className="btn-danger"
                        onClick={(e) => {
                            actionsLocalService.updateQuestionnaireProductList({
                                id: undefined,
                                externalKey: cellInfo.row.externalKey,
                                name: cellInfo.row.name,
                                category: cellInfo.row.category,
                                price: cellInfo.row.price,
                                count: -cellInfo.row.count,
                                riskCategory: ""
                            })
                        }}
                    >
                        x
                    </Button>
                </div>
            )
        }
    ]
}

export function createColumns() {
    const localizationStore = LocalizationStore.getInstance()

    return [
        {
            Header: localizationStore.t('PID'),
            maxWidth: 500,
            minWidth: 100,
            accessor: 'id',
            sortable: false,
            Cell: (cellInfo: CellInfo) => (
                <Link
                    className="catalogProductDetailLink"
                    to={'/catalogProduct/' + cellInfo.row.id}
                    id={cellInfo.row.name}
                >
                    {cellInfo.row.id}
                </Link>
            )
        },
        {
            Header: localizationStore.t('date'),
            accessor: 'createDate',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        },
        {
            Header: localizationStore.t('updateDate'),
            accessor: 'updateDate',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        }
        ,
        {
            Header: localizationStore.t('source'),
            accessor: 'source',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        }
        ,
        {
            Header: localizationStore.t('externalProductKey'),
            accessor: 'externalKey',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        }
        ,
        {
            Header: localizationStore.t('name'),
            accessor: 'name',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        }
        ,
        {
            Header: localizationStore.t('category'),
            accessor: 'category',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        }
        ,
        {
            Header: localizationStore.t('price'),
            accessor: 'price',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        }
        ,
        {
            Header: localizationStore.t('isActive'),
            accessor: 'isActive',
            maxWidth: 300,
            minWidth: 100,
            sortable: false
        }
    ]
}

export function createStub(products: Array<CatalogProduct>): Array<CatalogProductTableItem> {
    return products.map(x => new CatalogProductTableItem(x))
}

export function onFetchcCatalogProductsData(state: any, instance: any) {
    HttpActionsService
        .getInstance()
        .getCatalogProducts(
            state.page,
            state.pageSize,
            state.filtered,
            state.sorted)
}

export function getCatalogProductsTable() {
    const localizationStore = LocalizationStore.getInstance()
    const catalogProductsStore = CatalogProductsStore.getInstance()
    const configStore = ConfigStore.getInstance()

    return (
        <ReactTable
            pages={getPageCount()}
            data={createStub(catalogProductsStore.getList)}
            columns={createColumns()}
            defaultPageSize={configStore.getPageSize}
            className="-striped -highlight"
            noDataText={localizationStore.t('No data text')}
            filterable={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            previousText={localizationStore.t('Previous')}
            nextText={localizationStore.t('Next')}
            pageText={localizationStore.t('Page')}
            ofText={localizationStore.t('of')}
            manual
            onFetchData={_.debounce(onFetchcCatalogProductsData, 777)}
        />
    )
}

export function getCatalogProductsAddTable(pageSize: number = 15) {

    if (pageSize < 1) {
        pageSize = 15
    }

    const localizationStore = LocalizationStore.getInstance()
    const catalogProductsStore = CatalogProductsStore.getInstance()
    return (
        <ReactTable
            pages={getPageCount()}
            data={createStub(catalogProductsStore.getList)}
            columns={createColumnsAdd()}
            defaultPageSize={pageSize}
            className="-striped -highlight"
            noDataText={localizationStore.t('No data text')}
            filterable={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            previousText={localizationStore.t('Previous')}
            nextText={localizationStore.t('Next')}
            pageText={localizationStore.t('Page')}
            ofText={localizationStore.t('of')}
            manual
            onFetchData={_.debounce(onFetchcCatalogProductsData, 777)}
        />
    )
}

export function getQuestionnaireProductsTable() {
    const localizationStore = LocalizationStore.getInstance()
    const questionnairesStore = QuestionnairesStore.getInstance()
    const configStore = ConfigStore.getInstance()

    return (
        <ReactTable
            pages={getPageCount()}
            data={questionnairesStore.getItem.credit.products}
            columns={createColumnsQuestionnaireProducts()}
            defaultPageSize={configStore.getPageSize}
            className="-striped -highlight"
            noDataText={localizationStore.t('No data text')}
            filterable={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            previousText={localizationStore.t('Previous')}
            nextText={localizationStore.t('Next')}
            pageText={localizationStore.t('Page')}
            ofText={localizationStore.t('of')}
            manual
            onFetchData={_.debounce(onFetchcCatalogProductsData, 777)}
        />
    )
}
/// END TABLE

/// FORM

export function getCatalogProductForm() {
    const localizationStore = LocalizationStore.getInstance()
    const catalogProductsStore = CatalogProductsStore.getInstance()
    const userStore = UserStore.getInstance()

    let catalogProduct = catalogProductsStore.getItem

    if (!catalogProduct) {
        return (
            <div>
                <p>{localizationStore.t('no data')}</p>
                <Button
                    onClick={() => { history.push('/catalogProducts') }}
                >
                    {localizationStore!.t!('backToList')}
                </Button>
            </div>
        )
    }

    return (
        <Form
            schema={getCatalogProductFormScheme()}
            uiSchema={getCatalogProductFormUIScheme()}
            onSubmit={(e) => createOrUpdateCatalogProduct(e)}
            formData={catalogProduct}
            validate={validateCatalogProductForm}
            transformErrors={transformErrors}
        >
            <div className="catalogProductFormBtns">
                <Button
                    hidden={
                        !(
                            userStore!.checkAdmin ||
                            userStore!.checkCreditConsultant ||
                            userStore!.checkCreditExpert ||
                            userStore!.checkCashierAdmin ||
                            userStore!.checkCreditGroupAdministrator ||
                            userStore!.checkCollectionGroupAdministrator ||
                            userStore!.checkCatalogProductAdministrator ||
                            userStore!.checkSuperAdmin
                        )
                    }
                    type="submit"
                >
                    {localizationStore!.t!('Save')}
                </Button>
                <Button
                    onClick={() => { history.push('/catalogProducts') }}
                >
                    {localizationStore!.t!('backToList')}
                </Button>
            </div>
        </Form>
    )
}

export function getCatalogProductFormScheme(): any {
    return {
        type: 'object',
        required: [
            'name', 'source'
        ],
        properties: {
            id: {
                title: ls.t!('id'),
                type: 'string'
            },
            name: {
                title: ls.t!('name'),
                type: 'string'
            },
            isActive: {
                type: 'boolean',
                title: ls.t('isActive')
            },
            category: {
                type: 'string',
                title: ls.t('category')
            },
            externalKey: {
                type: 'string',
                title: ls.t('externalKey')
            },
            price: {
                type: 'number',
                title: ls.t('price')
            },
            source: {
                type: 'string',
                title: ls.t('source')
            }
        }
    }
}

export function getCatalogProductFormUIScheme() {
    return {
        'id': {
            'ui:readonly': true,
            'ui:help': ls.t('uneditable'),
        }
    }
}

export function transformErrors(errors: Array<AjvError>) {
    return errors.map((error: AjvError) => {
        if (error['name'] === 'required') {
            error['message'] = ls.t('is a required property')
        }
        if (error['params']['type'] === 'number') {
            error['message'] = ls.t('should be number')
        }
        if (error['message'] === 'should be equal to one of the allowed values') {
            error['message'] = ls.t('should be equal to one of the allowed values')
        }
        return error
    })
}

export function createOrUpdateCatalogProduct(e: ISubmitEvent<any>) {

    var catalogProduct = new CatalogProduct()

    catalogProduct.id = e.formData.id
    catalogProduct.isActive = e.formData.isActive
    catalogProduct.name = e.formData.name
    catalogProduct.category = e.formData.category
    catalogProduct.externalKey = e.formData.externalKey
    catalogProduct.price = e.formData.price
    catalogProduct.source = e.formData.source

    if (catalogProduct.id) {
        HttpActionsService.getInstance().updateCatalogProduct(catalogProduct)
    } else {
        HttpActionsService.getInstance().createCatalogProduct(catalogProduct)
    }
}

export function validateCatalogProductForm(formData: any, errors: FormValidation) {
    if (!formData.name) {
        errors.name.addError('Invalid name')
    }

    return errors
}

/// END FORM


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/CatalogProduct.tsx